import { render, staticRenderFns } from "./false-model.vue?vue&type=template&id=274f07f2&scoped=true&"
import script from "./false-model.vue?vue&type=script&lang=js&"
export * from "./false-model.vue?vue&type=script&lang=js&"
import style0 from "./false-model.vue?vue&type=style&index=0&id=274f07f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f07f2",
  null
  
)

export default component.exports